import { RouteConfig } from "vue-router";

export const RCompanyDocumentsBrowse: RouteConfig = {
  path: "",
  name: "ExpertCompanyDocumentsBrowse",
  component: () =>
    import(
      /* webpackChunkName: "expert-company-documents-browse" */
      "./VCompanyDocumentsBrowse.vue"
    ),
  meta: {
    label: "documents",
    title: "Companies",
  },
};
